import { ROUTES } from '@constants/routes';
import { generateUrl } from '@routes/util';
import { AnalyticsEvents } from '@services/analytics/AnalyticsEvents';
import { getAnalytics } from '@services/analytics/AnalyticsService';
import { useCallback, useState } from 'react';
import { useHistory } from 'react-router-dom';

export const useIntegrationModal = (initiativeId: string) => {
  const history = useHistory();
  const [code, setCode] = useState<string | undefined>();

  const onLinkClick = useCallback(
    ({ link, code }: { code: string; link?: string }) => {
      const analytics = getAnalytics();

      if (link) {
        analytics.track(AnalyticsEvents.IntegrationExternalView, { code, isExternal: true });
        return window.open(link);
      }
      analytics.track(AnalyticsEvents.IntegrationView, { code });
      return history.push(generateUrl(ROUTES.APP_INTEGRATIONS_VIEW, { initiativeId, code }));
    },
    [history, initiativeId],
  );
  return { code, setCode, onLinkClick };
};
